<template>
    <Card title="" loading="loading">
        <div>
        <select class="bg-transparent px-2 focus:outline-none focus:bg-gray-200 " v-model="listStatus" @change="getListings">
        <option value="active">Active Listing</option>
        <option value="inactive">Inactive Listing</option>
        </select>
        </div>
        <div class="row justify-content-end">
            <div class="col-md-4 col-sm-12 input-group">
                <input type="text" class="form-control" :placeholder="listingSearchPlaceholder" v-model="searchQuery" ignore>
                <div class="input-group-append">
                    <button class="btn btn-success" type="button" @click="search()">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <h1 class="text-center mt-4" v-if="loading">
            <i class="fas fa-spinner fa-pulse"></i>
        </h1>
        <h4 class="text-warning text-center" v-if="notFound">No listings were found.</h4>
        <h4 class="text-danger text-center" v-if="showError">There was an error loading listings.</h4>

        <div style="height: 275px;" class="overflow-scroll">
            <table v-if="!loading" class="table table-striped table-borderless ">
                <thead>
                <tr>
                    <th scope="col" class="hidden md:table-cell">MLS #</th>
                    <th scope="col" class=" md:table-cell">Address</th>
                    <th scope="col" class="hidden md:table-cell">Date Added</th>
                    <th scope="col" class=" md:table-cell">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(listing, index) in listings" v-bind:key="index">
                    <td class="hidden md:table-cell border-0" ignore>{{listing.mlsnum}}</td>
                    <td class="border-0 border-b" ignore>{{listing.address}}, {{listing.city}} {{listing.state}}</td>
                    <td class="hidden md:table-cell" ignore>{{listing.dates.listed}}</td>
                    <td class="flex flex-col flex-wrap justify-around md:flex-row border-0">

                        <div class="dropdown" v-if="listStatus=='active'">
                            <a class="btn btn-secondary dropdown-toggle w-100" href="#" role="button" id="dropdownMenuLink"
                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</a>

                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" id="listingActionDropdown">
                                <a class="dropdown-item"
                                   @click.prevent="goToAspen('propertyboost.htm', listing.homeid)"
                                   href="#" ignore>PropertyBoost</a>
                                <a class="dropdown-item"
                                   @click.prevent="goToAspen('listingSelect.htm?selectListing=' + listing.homeid + '&dest=listingLinks.htm', listing.homeid)"
                                   href="#">
                                    Tour Links
                                </a>
                                <a class="dropdown-item"
                                   :href="listing.tourURL" target="_blank">Virtual Tour</a>
                                <a class="dropdown-item"
                                   @click.prevent="goToAspen('listingSelect.htm?selectListing=' + listing.homeid + '&dest=flyerLinks2.htm', listing.homeid)"
                                   href="#"
                                   v-show="!hideMarketingMaterials()">
                                  {{printCenterText}}
                                </a>
                                <a class="dropdown-item"
                                   @click.prevent="goToAspen('listingSelect.htm?selectListing=' + listing.homeid + '&dest=tourImageInfo.htm', listing.homeid)"
                                   href="#">
                                    Edit Media
                                </a>
                                <a class="dropdown-item"
                                   @click.prevent="goToAspen('listingSelect.htm?selectListing=' + listing.homeid + '&dest=listingStatsNew.htm', listing.homeid)"
                                   href="#">
                                    Tour Stats
                                </a>
                            </div>
                        </div>
                        <router-link class="btn btn-success" :to="{name: 'listing-info', params: {id: listing.id}}">View</router-link>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>


        <div v-show="redirecting" class="loading">
            <div class="fa-3x">
                <span>Redirecting Please Wait</span> <i class="fas fa-sync fa-spin"></i>
            </div>
        </div>
        <template #footer>
            <a class="text-danger" :href="`${cpixdomain}/aspen/ssRedirect.php`">+ Add Listing</a>
        </template>
    </Card>
</template>
<script>
  import Card from "../components/Card";
  import {cpixdomain} from "../config";
  import {mapGetters} from 'vuex';

  export default {
    name: "ListingTableCard",
    components: {
      Card
    },
    data() {
      return {
        listings: null,
        searchQuery: "",
        searchTimeout: null,
        loading: true,
        notFound: false,
        showError: false,
        redirecting: false,
        listStatus: 'active'
      };
    },
    computed: {
      ...mapGetters([
        'me'
      ]),
      cpixdomain() {
        return cpixdomain
      },
      printCenterText() {
        if(this.me.tokenUser.company.CMPid === 102999 || this.me.tokenUser.company.parentCMPid === 102999) {
          return "Print Centre";
        }
        return "Print Center";
      },
      langCode() {
        if(typeof this.me.tokenUser.preferences !== 'undefined' && typeof this.me.tokenUser.preferences[719] !== 'undefined') {
          return this.me.tokenUser.preferences[719].PREFvalue;
        }
        return 'en';
      },
      listingSearchPlaceholder() {
        return this.langCode === 'fr-CA' ? 'Rechercher' : "Search";
      },
    },
    methods: {
      goToAspen(link, homeid) {
        this.redirecting = true;
        this.$http.get('/switchListing/' + homeid).then(() => {
          window.location.href = cpixdomain + '/aspen/' + link;
        }).catch(() => {
          // eslint-disable-next-line
          console.log('Could not switch listing');
          this.redirecting = false;
        });

      },
      search() {
        if (this.searchQuery == "") {
          this.loadAll();
        } else {
          this.startLoading();
          this.$http
            .get(`/homes/search/?query=${escape(this.searchQuery)}&status=${escape(this.listStatus)}&includeCoList=1`)
            .then(res => {
              this.listings = res.data;
            }).catch((err) => {
            if (err.response.status == 404) {
              this.listings = null;
              this.notFound = true;
            } else {
              this.showError = true;
            }
          })
            .finally(() => {
              this.resetErrors();
            });
        }
      },
      loadAll() {
        this.startLoading();
        this.$http
          .get("/homes?includeCoList=1")
          .then(res => {
            this.listings = res.data;
            this.listings.forEach(listing => {
              // set tour URL
              listing.tourURL = `http://tour.corelistingmachine.com/home/${listing.id}`;

              // convert date
              let d = new Date(listing.listdate);
              listing.listdate = d.toDateString();
            });
          })
          .catch(() => {
            this.showError = true;
          })
          .finally(() => {
            this.resetErrors();
          });
      },
      startLoading() {
        this.showError = false;
        this.notFound = false;
        this.loading = true;
      },
      resetErrors() {
        this.loading = false;
      },
      hideMarketingMaterials() {
        if(typeof this.me.tokenUser.company.preferences[712] !== 'undefined') {
          return this.me.tokenUser.company.preferences[712].PREFvalue === "true";
        }

        return false;
      },
      getListings() {
        this.startLoading();
        if(this.listStatus == "active") {
          this.loadAll();
        } else {
        this.$http.get(`/homes/inactive?includeCoList=1`)
          .then(res => {
            let arr = {};
            let result = [];
              res.data.forEach((val) => {
                    arr = val;
                    arr.dates = {
                      listed: val.all_fields.date_posted
                    }
                    result.push(arr);
                  });
              this.listings = result;
            }).catch(() => {
              this.showError = true;
          })
            .finally(() => {
              this.resetErrors();
            });

      }
      },

    },
    watch: {
      searchQuery: function (nVal, oldVal) {
        if (nVal != oldVal) {
          clearTimeout(this.searchTimeout);
          this.searchTimeout = setTimeout(() => {
            this.search();
          }, 1000);
        }
      }
    },
    mounted: function () {
      this.loadAll();
    }
  };
</script>

<style lang="scss" scoped>
    .dropdown > a {
        color: #fff;
    }

    #listingActionDropdown {
      width: 235px;
    }

    .loading {
        background: rgba(200, 200, 200, 0.8);
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 999;

        > div {
            width: 100%;
            text-align: center;
            margin-top: 50px;

            span {
                font-size: 16px;
                display: block;
                color: #000
            }

            i {
                color: #000;
            }
        }
    }
</style>
